import { createSlice } from '@reduxjs/toolkit'

import { logout } from './session'

import { RootState } from '.'

interface ModalState {
	showModal: boolean
}

const initialState: ModalState = {
	showModal: false,
}

export const modalSlice = createSlice({
	name: 'modal',
	initialState,
	reducers: {
		displayModal: (state) => {
			state.showModal = true
		},
		hideModal: (state) => {
			state.showModal = false
		},
	},
	extraReducers: (builder) => {
		builder.addCase(logout, () => {
			return initialState
		})
	},
})

export const { displayModal, hideModal } = modalSlice.actions

export const selectShowModal = (state: RootState): boolean => state.modal.showModal

export default modalSlice.reducer
